import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import {
  skippedSearchSchema,
  type SkippedSearch,
} from '~/features/catalog-enrichment/utils/run-products-search';

const RunSkippedPage = lazy(() => import('~/features/catalog-enrichment/pages/run-skipped-page'));

/** The Products tab's Skipped view: products the batch left out because they were already curated. */
export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/products/skipped',
)({
  validateSearch: skippedSearchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { runId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  const onSearchChange = (patch: Partial<SkippedSearch>) => {
    void navigate({ search: (prev) => ({ ...prev, ...patch }) });
  };

  return (
    <Suspense fallback={<PageSkeleton />}>
      <RunSkippedPage key={runId} runId={runId} search={search} onSearchChange={onSearchChange} />
    </Suspense>
  );
}
